import React from "react";
import { v2cx } from "../../theme/tokens";

/**
 * Thumb-zone action tray for entity detail.
 * Shell stacks this above the persistent bottom tab bar (no extra offset needed).
 * Items: { key, label, icon, onClick, primary?, danger?, disabled? }
 */
export default function MobileActionTray({ items = [], className }) {
  if (!items.length) return null;

  return (
    <div
      className={v2cx(
        "lg:hidden shrink-0 border-t border-slate-200 bg-white/95 backdrop-blur",
        // Safe-area lives on the tab bar below; keep tray padding light.
        "pb-1.5",
        className
      )}
      role="toolbar"
      aria-label="Actions"
    >
      <div className="grid grid-flow-col auto-cols-fr gap-1 px-2 pt-1.5 pb-1">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            disabled={item.disabled}
            onClick={item.onClick}
            className={v2cx(
              "flex min-h-[3.25rem] flex-col items-center justify-center gap-0.5 rounded-xl px-1 py-1 text-[10px] font-medium touch-manipulation transition-colors disabled:opacity-40",
              item.danger
                ? "text-rose-700 active:bg-rose-50"
                : item.primary
                  ? "text-blue-700 bg-blue-50 active:bg-blue-100"
                  : "text-slate-600 active:bg-slate-100"
            )}
          >
            {item.icon ? (
              <span className="inline-flex h-5 w-5 items-center justify-center" aria-hidden>
                {item.icon}
              </span>
            ) : null}
            <span className="leading-none">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
